import { render, staticRenderFns } from "./bcpassword.vue?vue&type=template&id=61735380&scoped=true"
import script from "./bcpassword.vue?vue&type=script&lang=js"
export * from "./bcpassword.vue?vue&type=script&lang=js"
import style0 from "./bcpassword.vue?vue&type=style&index=0&id=61735380&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61735380",
  null
  
)

export default component.exports